import { render, staticRenderFns } from "./TemplateCardCategory.vue?vue&type=template&id=4e7c3a49&scoped=true&"
import script from "./TemplateCardCategory.vue?vue&type=script&lang=js&"
export * from "./TemplateCardCategory.vue?vue&type=script&lang=js&"
import style0 from "./TemplateCardCategory.vue?vue&type=style&index=0&id=4e7c3a49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e7c3a49",
  null
  
)

export default component.exports